<iframe
  width="100%"
  height="100%"
  class="iframe-border"
  [src]="urlSafe"
  title="shippersFrame">
</iframe>
